import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
    scrollBehavior: (to, from, savedPosition) => {
        if (savedPosition) {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve(savedPosition)
                }, 500)
            })
        }
        if (to.hash) {
            return { selector: to.hash }
        }
        return { x: 0, y: 0 }
    },
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'top',
            component: () => import('./views/Top.vue')
        },
        {
            path: '/terms',
            name: 'terms',
            component: () => import('./views/other/Terms.vue'),
            meta: { title: "利用規約" }
        },
        {
            path: '/transactions',
            name: 'transactions',
            component: () => import('./views/other/Transactions.vue'),
            meta: { title: "特定商取引法に基づく表示" }
        },
        {
            path: '/privacy',
            name: 'privacy',
            component: () => import('./views/other/Privacy.vue'),
            meta: { title: "個人情報保護方針" }
        },
        {
            path: '/qa',
            name: 'qa',
            component: () => import('./views/other/Qa.vue'),
            meta: { title: "Q & A" }
        },
        {
            path: '/guide',
            name: 'guide',
            component: () => import('./views/other/Guide.vue'),
            meta: { title: "ご利用ガイド" }
        },
        {
            path: '/mypage',
            name: 'mypage',
            component: () => import('./views/mypage/Mypage.vue'),
            props: { type: 'mypage', },
            meta: { title: "マイページ" }
        },
        {
            path: '/signup',
            name: 'signup',
            component: () => import('./views/mypage/SignUp.vue'),
            props: { type: 'signup', },
            meta: { title: "会員登録" }
        },
        {
            path: '/reminder',
            name: 'reminder',
            component: () => import('./views/mypage/SignUp.vue'),
            props: { type: 'reminder', },
            meta: { title: "パスワード再設定" }
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('./views/mypage/Login.vue'),
            meta: { title: "ログイン" }
        },
        {
            path: '/mypage/profile',
            name: 'mypage-profile',
            component: () => import('./views/mypage/Profile.vue'),
            meta: { title: "会員情報確認・編集" }
        },
        {
            path: '/mypage/password',
            name: 'mypage-password',
            component: () => import('./views/mypage/Password.vue'),
            meta: { title: "パスワード変更" }
        },
        {
            path: '/mypage/email',
            name: 'mypage-email',
            component: () => import('./views/mypage/Email.vue'),
            meta: { title: "メール設定" }
        },
        {
            path: '/mypage/payment',
            name: 'mypage-payment',
            component: () => import('./views/mypage/Payment.vue'),
            meta: { title: "登録クレジットカード変更・確認" }
        },
        {
            path: '/mypage/orderHistory',
            name: 'mypage-orderHistory',
            component: () => import('./views/mypage/OrderHistory.vue'),
            meta: { title: "購入履歴" }
        },
        {
            path: '/mypage/orderHistory/:no',
            name: 'mypage-orderHistory-details',
            component: () => import('./views/mypage/OrderHistoryDetails.vue'),
            meta: { title: "購入履歴詳細" }
        },
        {
            path: '/mypage/product',
            name: 'mypage-product',
            component: () => import('./views/mypage/UserProduct.vue'),
            meta: { title: "当選景品" }
        },
        {
            path: '/mypage/product/:directoryName',
            name: 'mypage-product-details',
            component: () => import('./views/mypage/UserProductDetails.vue'),
            meta: { title: "当選景品詳細" }
        },
        {
            path: '/mypage/userShip',
            name: 'mypage-userShip',
            component: () => import('./views/mypage/UserShip.vue'),
            meta: { title: "配送履歴" }
        },
        {
            path: '/mypage/userShip/:no',
            name: 'mypage-userShip-details',
            component: () => import('./views/mypage/UserShipDetails.vue'),
            meta: { title: "配送履歴詳細" }
        },
        {
            path: '/mypage/leave',
            name: 'mypage-leave',
            component: () => import('./views/mypage/Leave.vue'),
            props: { type: 'mypage-leave', },
            meta: { title: "退会" }
        },
        {
            path: '/product',
            name: 'product',
            component: () => import('./views/product/Product.vue'),
            meta: { title: "くじ一覧" }
        },
        {
            path: '/product/:directoryName',
            name: 'product-details',
            component: () => import('./views/product/ProductDetails.vue'),
            meta: { title: "くじ詳細" }
        },
        {
            path: '/product/:directoryName/shopping',
            name: 'product-shopping',
            component: () => import('./views/product/Shopping.vue'),
            meta: { title: "購入内容確認" }
        },
        {
            path: '/product/:directoryName/result',
            name: 'product-result',
            component: () => import('./views/product/Result.vue'),
            meta: { title: "抽選" }
        },
        {
            path: '/product/:directoryName/resultall',
            name: 'product-resultall',
            component: () => import('./views/product/ResultAll.vue'),
            meta: { title: "抽選結果" }
        },
    ]
});

router.afterEach((to, from) => {

    const DEFAULT_TITLE = '推しちゃれ | CHARA-ART プレミアムくじ';
    const DEFAULT_KEYWORDS = '推しちゃれ,プレミアムくじ,CHARA-ART,くじ,オンラインくじ,オンライン';
    const DEFAULT_DESCRIPTION = '推しちゃれは、1回から購入できるハズレなしのオンラインくじです。';
    const DEFAULT_IMAGE = 'https://oshi-challe.jp/apple-touch-icon.png';

    const DEFAULT_URL = 'https://oshi-challe.jp';
    router.afterEach((to, from) => {
        document.title = to.meta!.title ? to.meta!.title + " | " + DEFAULT_TITLE : '推しちゃれ | CHARA-ART プレミアムくじ';
        document.getElementById("meta-keywords")!.setAttribute('content', to.meta!.title ? to.meta!.title + "," + DEFAULT_KEYWORDS : DEFAULT_KEYWORDS);
        document.getElementById("meta-description")!.setAttribute('content', to.meta!.title ? to.meta!.title + "のページです。" + DEFAULT_DESCRIPTION : DEFAULT_DESCRIPTION);
        document.getElementById("ogpCard")!.setAttribute('content', 'summary');
        document.getElementById("ogpTitle")!.setAttribute('content', to.meta!.title ? to.meta!.title + " | " + DEFAULT_TITLE : '推しちゃれ | CHARA-ART プレミアムくじ');
        document.getElementById("ogpDescription")!.setAttribute('content', to.meta!.title ? to.meta!.title + "のページです。" + DEFAULT_DESCRIPTION : DEFAULT_DESCRIPTION);
        document.getElementById("ogpImg")!.setAttribute('content', to.meta!.image ? to.meta!.image : DEFAULT_IMAGE);

        document.getElementById("canonical")!.setAttribute('href', DEFAULT_URL + to.path );
    })
})

export default router;